<template>
  <div>
    <div>
      <label>Selecione a opção desejada:</label>
      <div class='btn-radio w-100 d-flex flex-wrap justify-content-between'>
        <button
          @click='setHits(acessosParaMimMinhaEquipe.key)'
          :class="billingData.hits === acessosParaMimMinhaEquipe.key ? 'hits_select ':'hits_no_select'"
        >
          <span>{{ acessosParaMimMinhaEquipe.value }}</span>
        </button>

        <button
          @click='setHits(acessoParaMim.key)'
          :class="billingData.hits === acessoParaMim.key ? 'hits_select ':'hits_no_select'"
        >
          <span>{{ acessoParaMim.value }}</span>
        </button>
      </div>
    </div>

    <section class='resume mb-4 mt-4'>
      <p class='resume-title'>PLANO ANUAL — resumo da sua contratação:</p>

      <ul class='resume-list'>
        <li><strong>Consultas: ilimitadas</strong> durante todo o período;</li>
        <li>
          <strong>Sem renovação automática:</strong> ao final do período, nada é cobrado sem a sua ação. Avisaremos ao
          menos 30 dias antes do término, via e-mail, plataforma HO Fácil Web e whatsapp sobre sua condição de renovação;
        </li>
        <li>
          <strong>Garantia de 30 dias:</strong> cancelando em até 30 dias corridos da cobrança, devolvemos 100% do valor
          pago;
        </li>
        <li>
          Novas funcionalidades do sistema são liberadas para você <strong>automaticamente e sem custo*</strong> durante
          a vigência do plano contratado. (*Exceto as que possam ser implementadas e adquiridas somente como módulo
          adicional);
        </li>
        <li>
          Possibilidade de acessos adicionais para sua equipe (usuários subordinados), com desconto de 10% a 20% na
          aquisição destes.
        </li>
      </ul>
    </section>

    <div>
      <label>
        Selecione o tempo de contrato:
      </label>
      <b-form-select
        v-model='v$.billingData.contractTimeYears.$model'
        :options='quantitiesAccessInYears'
         style='height: 40px'
        value-field='key'
        text-field='value'
        @change='setQuantidadeAcessoEmAnos()'
      >
        <template #first>
          <b-form-select-option :value='0' disabled>Selecione o tempo de contrato aqui</b-form-select-option>
        </template>
      </b-form-select>
    </div>

    <div v-if="billingData.contractTimeYears && billingData.contractTimeYears > 0" class="mt-4">
      <div class='my-3' v-if="billingData.hits === 'acessos_para_mim_minha_equipe'">
        <label>
          Selecione a quantidade adicional de acessos que você pretende contratar para seus colaboradores (descontos a
          partir de 10%):
        </label>

        <div>
          <b-form-select
            v-model='v$.billingData.numberAccesses.$model'
            :options='employees'
            class='mb-3'
            style='height: 40px'
            value-field='key'
            text-field='value'
            @change='calculateTotal()'
          >
            <template #first>
              <b-form-select-option :value='0' disabled>Selecione a quantidade de colaboradores</b-form-select-option>
            </template>
          </b-form-select>

          <div class='p-2' v-if='billingData.numberAccesses > 0'>
            <p>
              Você selecionou uma opção que acrescenta na sua compra usuários subordinados. Nesta
              opção oferecemos um desconto que é aplicável somente à compra dos usuários
              subordinados. Abaixo você terá um descritivo desta opção de compra:
            </p>

            <ul class="ml-3">
              <li>
                <strong>Usuário Master:</strong>
                <ul class="ml-4">
                  <li>Quantidade 1 unidade</li>
                  <li v-if="appliedMasterDiscountPercentage > 0" class="discount-tag">
                    <i class="fa fa-tag" />
                    Desconto elegível ao usuário master: <strong>{{ appliedMasterDiscountPercentage }}%</strong>
                    <i
                      v-if="accumulatedDiscountDetails.eligible"
                      id="master-discount-info-team"
                      class="fa fa-info-circle discount-info-icon"
                    />
                    <b-popover
                      v-if="accumulatedDiscountDetails.eligible"
                      target="master-discount-info-team"
                      triggers="hover focus"
                      placement="top"
                      custom-class="discount-rules-popover"
                    >
                      <div class="discount-rules-content" v-html="discountRulesHtml"></div>
                    </b-popover>
                  </li>
                  <li>
                    Preço:
                      <span v-if="discount" style="text-decoration: line-through; color:#bc0000;">
                        {{formatRealCurrent(parseFloat(getPlan.value)  * parseInt(billingData.contractTimeYears))}}
                      </span>
                      <span v-if="discount">&nbsp;&nbsp;</span>
                      <span>
                        {{
                          formatRealCurrent((parseFloat(getPlan.value) - parseFloat(getDiscount)) * parseInt(billingData.contractTimeYears))
                        }}
                      </span>
                  </li>
                </ul>
              </li>
              <li class="mt-1">
                <strong>Usuário subordinado:</strong>
                <ul class="ml-4">
                  <li>Quantidade {{ billingData.numberAccesses }} unidade(s)</li>
                  <li class="discount-tag">
                    <i class="fa fa-tag" />
                    Desconto elegível ao usuário subordinado: <strong>{{ percentage(billingData.numberAccesses) }}%</strong>
                  </li>
                  <li>
                    Preço: <span style="text-decoration: line-through; color:#bc0000;">
                    {{formatRealCurrent(((parseFloat(getPlan.value) - parseFloat(getDiscount)) * parseInt(billingData.contractTimeYears)) * billingData.numberAccesses)}}
                  </span>
                  <span>&nbsp;&nbsp; {{formatRealCurrent(parseFloat(billingData.precoCompraUsuariosSubordinados))}}</span>
                  </li>
                </ul>
              </li>
              <li class="mt-1">
                <strong>Total a pagar considerando usuário master e subordinados:</strong>
                <ul class="ml-4">
                  <li>
                    <strong>Preço:
                      {{formatRealCurrent(Number(billingData.precoCompraUsuariosSubordinados) + ((parseFloat(getPlan.value) - parseFloat(getDiscount)) * parseInt(billingData.contractTimeYears)))}}
                    </strong>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div v-else class='p-2 my-3'>
        <ul class="ml-3">
          <li>
            <strong>Usuário Master:</strong>
            <ul class="ml-4">
              <li>Quantidade 1 unidade</li>
              <li v-if="appliedMasterDiscountPercentage > 0" class="discount-tag">
                <i class="fa fa-tag" />
                Desconto elegível ao usuário master: <strong>{{ appliedMasterDiscountPercentage }}%</strong>
                <i
                  v-if="accumulatedDiscountDetails.eligible"
                  id="master-discount-info-solo"
                  class="fa fa-info-circle discount-info-icon"
                />
                <b-popover
                  v-if="accumulatedDiscountDetails.eligible"
                  target="master-discount-info-solo"
                  triggers="hover focus"
                  placement="top"
                  custom-class="discount-rules-popover"
                >
                  <div class="discount-rules-content" v-html="discountRulesHtml"></div>
                </b-popover>
              </li>
              <li>
                Preço:
                  <span v-if="discount" style="text-decoration: line-through; color:#bc0000;">
                    {{formatRealCurrent(parseFloat(getPlan.value) * parseInt(billingData.contractTimeYears))}}
                  </span>
                  <span v-if="discount">&nbsp;&nbsp;</span>
                  <span>
                    {{
                      formatRealCurrent((parseFloat(getPlan.value) - parseFloat(getDiscount)) * parseInt(billingData.contractTimeYears))
                    }}
                  </span>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>

    <div class='mt-1'>
      <b-alert
        show
        variant='danger'
        :class='{ hidden: !errors }'
      >
        {{ errors }}
      </b-alert>
    </div>

    <section v-if="showBtns" class='buttons d-flex justify-content-between align-items-center'>
      <base-button
        class='nav-btn'
        dark
        @click="$emit('back-step')"
      >
        Voltar
      </base-button>

      <b-overlay
        :show='loading'
        rounded
        opacity='0.6'
        spinner-small
        spinner-variant='primary'
        class='d-inline-block'
      >
        <base-button
          class='nav-btn'
          @click='next()'
        >
          Próximo
        </base-button>
      </b-overlay>
    </section>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import moment from 'moment'
import { required } from '@/utils/validators'
import { mask } from 'vue-the-mask'
import { mapActions, mapGetters } from 'vuex'
import { formatRealCurrent } from '@/utils/format'

export default {
  name: 'BillingData',
  setup() {
    return { v$: useVuelidate() }
  },
  props: {},
  async mounted() {
    this.billingData.numeroUsuariosExistentes = 0
    this.generateOptionsNumberEmployees()
    await this.calculateTotal()
    await this.$store.dispatch('access/updateError', '')
    this.quantitiesAccessInYears = [
      {
        key: 1,
        value: '1 ano de acesso',
      },
      {
        key: 2,
        value: '2 anos de acesso',
      },
      {
        key: 3,
        value: '3 anos de acesso',
      },
      {
        key: 4,
        value: '4 anos de acesso',
      },
    ]
    const { contractTimeYears } = this.getPlan
    if(contractTimeYears && contractTimeYears.length > 0){
      this.quantitiesAccessInYears = contractTimeYears
        .sort((x, y) => x - y)
        .map(x => Number(x))
        .map((x) => {
          return  {
            key: x,
            value: `${x} ${x > 1 ? 'anos' : 'ano'} de acesso`
          }
      })
    }

  },
  data() {
    return {
      loading: false,
      disableButtonToNotBuyOutOfTimePlan: true,
      plans: {},
      access: [],
      employees: [],
      contractTimeYears: null,
      quantitiesAccessInYears: [],
      diasEmUmAno: 365,
      numeroUsuariosExistentes: 0,
      totalPrice: 0,
      amountAccessCollaborator: 0,
      planPrice: 0,
      birthDate: '',
      document: '',
      plan: {},
      acessosParaMimMinhaEquipe: {
        key: 'acessos_para_mim_minha_equipe',
        value: 'Quero comprar acessos para mim e minha equipe',
      },
      acessoParaMim: {
        key: 'acesso_para_mim',
        value: 'Quero somente para mim'
      }
    }
  },
  directives: { mask },
  computed: {
    ...mapGetters('user', {
      user: 'current'
    }),
    ...mapGetters('checkout2', {
      billingData: 'getBillingData',
      getPlan: 'getPlan',
      getDiscount: 'getDiscount'
    }),
    ...mapGetters('plans', {
      getPlans: 'getPlans'
    }),
    ...mapGetters('promocodes', {
      discount: 'discount',
      accumulatedDiscountDetails: 'accumulatedDiscountDetails',
    }),
    errors() {
      return this.$store.getters['access/error']
    },
    accumulatedAdditionalDiscount() {
      const months = Number(this.accumulatedDiscountDetails.totalMonthsDiscountPercentage) || 0
      const years = Number(this.accumulatedDiscountDetails.totalYearsDiscountPercentage) || 0
      return Number((months + years).toFixed(2))
    },

    appliedMasterDiscountPercentage() {
      const planValue = parseFloat(this.getPlan && this.getPlan.value) || 0
      const discountValue = parseFloat(this.getDiscount) || 0
      if (planValue <= 0) return 0
      return Number(((discountValue / planValue) * 100).toFixed(2))
    },

    discountRulesHtml() {
      const details = this.accumulatedDiscountDetails
      return `
        <p><strong>Desconto disponível para este usuário: ${details.totalDiscountPercentage}%</strong> <i class="fa fa-info-circle"></i></p>
        <p><strong>Como este desconto foi calculado?</strong></p>
        <p>O desconto disponível é formado pela soma do <strong>desconto base de ${details.discountPercentage}%</strong> com o <strong>desconto adicional acumulado pelo histórico de permanência do usuário</strong>.</p>
        <p><strong>Neste caso:</strong></p>
        <ul>
          <li>Desconto base: <strong>${details.discountPercentage}%</strong></li>
          <li>Desconto acumulado pelo histórico: <strong>${this.accumulatedAdditionalDiscount}%</strong></li>
          <li><strong>Desconto total disponível: ${details.totalDiscountPercentage}%</strong></li>
        </ul>
        <p>O desconto adicional é acumulado da seguinte forma:</p>
        <ul>
          <li><strong>Plano mensal:</strong> +0,083333% a cada mês pago;</li>
          <li><strong>Plano anual:</strong> +1% a cada ano completado.</li>
        </ul>
        <p>O desconto total calculado por essa regra é limitado a <strong>25%</strong>.</p>
        <p>Caso o usuário também esteja incluído em outra condição ou campanha de renovação, os descontos serão comparados e será aplicado <strong>o maior percentual disponível</strong>.</p>
      `
    },
    showBtns() {
      if (!this.billingData.contractTimeYears) {
        return false;
      }
      if (this.billingData.hits === this.acessosParaMimMinhaEquipe.key && (!this.billingData.numberAccesses || this.billingData.numberAccesses < 1)) {
        return false;
      }
      return true
    }
  },

  validations() {
    return {
      billingData: {
        numberAccesses: {},
        hits: { required },
        contractTimeYears: { },
      }
    }
  },
  methods: {
    ...mapActions('checkout2', {
      handleSetPlan: 'handleSetPlan',
      handleSetBillingData: 'handleSetBillingData',
      handleGetAmountPaidPlan: 'handleGetAmountPaidPlan',
      calculateTotalPlan: 'calculateTotalPlan',
      handleSeNumberAccesses: 'handleSeNumberAccesses',
      handleSetQuantidadeAcessoEmAnos: 'handleSetQuantidadeAcessoEmAnos',
      handleSetHits: 'handleSetHits',
    }),
    ...mapActions('userActionLogs', {
      createUserActionLogs: 'createUserActionLogs'
    }),
    ...mapActions('plans', {
      handleSetPlanCuston: 'handleSetPlanCuston'
    }),
    formatRealCurrent,
    async setHits(hits) {
      await this.handleSetHits(hits)
      await this.handleSeNumberAccesses(0)
      await this.calculateTotal()
    },
    generateOptionsNumberEmployees() {
      for (let employee = 1; employee <= 10; employee++) {
        this.employees.push({
          key: employee,
          value: `${employee} ${employee > 1 ? 'colaboradores adicionais ' : 'colaborador adicional'} `
        })
      }
    },
    percentage(quantidadeColaboradores) {
      switch (quantidadeColaboradores) {
        case 1: {
          return 10
        }
        case 2: {
          return 11
        }
        case 3: {
          return 12
        }
        case 4: {
          return 13
        }
        case 5: {
          return 14
        }
        case 6: {
          return 15
        }
        case 7: {
          return 16
        }
        case 8: {
          return 17
        }
        case 9: {
          return 18
        }
        case 10: {
          return 19
        }
      }
    },
    async setQuantidadeAcessoEmAnos() {
      await this.calculateTotal()
    },
    async calculateTotal() {
      await this.$store.dispatch('access/updateError', '')
      this.access = []
      for (let i = 1; i <= this.billingData.numberAccesses; i++) {
        const percentage = this.percentage(i + this.amountAccessCollaborator)
        this.access.push(
          {
            quantidadeAcesso: i,
            discount: percentage.toString().replace('.', ',')
          }
        )
      }
      if (this.getPlan && this.getPlan.value) {
        await this.calculateTotalPlan()
      }
    },
    async next() {
      await this.$store.dispatch('access/updateError', '')
      if(!this.billingData.contractTimeYears || this.billingData.contractTimeYears < 1){
        await this.$store.dispatch('access/updateError', 'Selecione quantos anos de acesso!')
        return
      }

      if(this.billingData.hits == 'acessos_para_mim_minha_equipe' && (!this.billingData.numberAccesses || this.billingData.numberAccesses < 1)){
        await this.$store.dispatch('access/updateError', 'Selecione a quantidade de colaboradores!')
        return
      }
      this.$emit('next-step')
    },
  },



  created() {
    try {
    } catch (e) {

    }
  }
}
</script>

<style lang='scss' scoped>
.buttons {
  margin-top: 24px;
}

.nav-btn {
  min-width: 140px;
  padding: 12px 20px;
}

.hits_select {
  text-align: center;
  border: 1px solid #04A8F3;
  padding: 5px;
  border-radius: 6px;
  background: #CBD63E;
  color: #262626;
  font-weight: 700;
  width: 49%;
  font-size: 15px;
}

.hits_no_select {
  border: 1px solid #04A8F3;
  padding: 5px;
  border-radius: 6px;
  background: transparent;
  color: #04A8F3;
  font-weight: 700;
  width: 49%;
  font-size: 15px;
}
label {
  font-size: 17px;
  font-weight: 700;
  color: #262626;
}

.resume {
  background: #eef1f6;
  border-radius: 8px;
  padding: 24px 28px;
  color: #1c2439;
}

.resume-title {
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 16px;
}

.resume-list {
  margin: 0;
  padding-left: 20px;

  li {
    font-size: 15px;
    line-height: 1.5;
    margin-bottom: 14px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}
.discount-tag {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #eef4d6;
  color: #4a6b00;
  border-radius: 6px;
  padding: 6px 10px;
  margin: 6px 0;
  list-style: none;

  .fa-tag {
    color: #6b8e00;
  }
  .discount-info-icon {
    color: #04a8f3;
    cursor: pointer;
  }
}
</style>

<style lang="scss">
.popover.discount-rules-popover {
  width: 520px;
  max-width: calc(100vw - 32px);

  .discount-rules-content {
    text-align: left;
    font-size: 15px;
    line-height: 1.4;

    p {
      margin-bottom: 8px;
    }
    ul {
      padding-left: 18px;
      margin-bottom: 8px;
    }
  }
}
</style>
